import { ProfileOptionItem } from '../models/profileoption.model';
import { TranslateService } from '@ngx-translate/core';

/**
 * Obtener opciones de perfil
 * @param translate Servicio de traducción
 * @returns Opciones de perfil
 */
function getProfileOptions(translate: TranslateService): ProfileOptionItem[] {
  return [
    {
      label: 'layout.topbar.profile',
      icon: 'fe-user',
      redirectTo: '/profile',
    },
    {
      label: 'layout.topbar.logout',
      icon: 'fe-log-out',
      redirectTo: '/auth/logout',
    },
  ];
}

export { getProfileOptions };
